import moment from "moment";

export const calculateWorkload = (hr_inicio, hr_termino) => {
    if (hr_inicio && hr_termino) {
        const formatoHora = "HH:mm";
        const inicioMoment = moment(hr_inicio, formatoHora);
        const terminoMoment = moment(hr_termino, formatoHora);

        const duracao = moment.duration(terminoMoment.diff(inicioMoment));
        const minutosTotais = duracao.asMinutes();

        const entidadeId = localStorage.getItem("entidade_id");
        let minutosFinais = 0;
        if (entidadeId === "3") {
            minutosFinais = minutosTotais
        }
        else {
            const minutosMinimos = Math.max(minutosTotais, 60);
            minutosFinais = Math.ceil(minutosMinimos / 30) * 30;
        }

        const cargaHorariaFormatada = moment.utc(minutosFinais * 60000).format("HH:mm");

        return cargaHorariaFormatada
    }
};